// Admin Reports
export default function AdminReports() { return <div><h1 className="text-3xl font-bold">Reports</h1><p className="mt-4">View bookings and revenue reports.</p></div>; }